// Auto-generated from assets/cards/generated-filtered. Do not edit card entries by hand.
export const CARD_CATALOG = [
    {
        "id":  "base_fire_03_ember_duelist",
        "name":  "Ember Duelist",
        "element":  "fire",
        "tier":  "300-390",
        "score":  310,
        "image":  "/assets/cards/generated-filtered/fire/300-390/base_fire_03_ember_duelist__card.png"
    },
    {
        "id":  "exp01_fire_05_desert_flame_monk",
        "name":  "Desert Flame Monk",
        "element":  "fire",
        "tier":  "300-390",
        "score":  326,
        "image":  "/assets/cards/generated-filtered/fire/300-390/exp01_fire_05_desert_flame_monk__card.png"
    },
    {
        "id":  "exp02_fire_04_candle_grave_lighter",
        "name":  "Candle Grave Lighter",
        "element":  "fire",
        "tier":  "300-390",
        "score":  342,
        "image":  "/assets/cards/generated-filtered/fire/300-390/exp02_fire_04_candle_grave_lighter__card.png"
    },
    {
        "id":  "exp03_fire_02_cinder_plague_doctor",
        "name":  "Cinder Plague Doctor",
        "element":  "fire",
        "tier":  "300-390",
        "score":  358,
        "image":  "/assets/cards/generated-filtered/fire/300-390/exp03_fire_02_cinder_plague_doctor__card.png"
    },
    {
        "id":  "exp04_fire_01_smoke_flame_matador",
        "name":  "Smoke Flame Matador",
        "element":  "fire",
        "tier":  "300-390",
        "score":  374,
        "image":  "/assets/cards/generated-filtered/fire/300-390/exp04_fire_01_smoke_flame_matador__card.png"
    },
    {
        "id":  "exp04_fire_04_salamander_ash_oracle",
        "name":  "Salamander Ash Oracle",
        "element":  "fire",
        "tier":  "300-390",
        "score":  390,
        "image":  "/assets/cards/generated-filtered/fire/300-390/exp04_fire_04_salamander_ash_oracle__card.png"
    },
    {
        "id":  "base_fire_04_ash_gladiator",
        "name":  "Ash Gladiator",
        "element":  "fire",
        "tier":  "400-490",
        "score":  405,
        "image":  "/assets/cards/generated-filtered/fire/400-490/base_fire_04_ash_gladiator__card.png"
    },
    {
        "id":  "exp01_fire_02_ash_veil_witch",
        "name":  "Ash Veil Witch",
        "element":  "fire",
        "tier":  "400-490",
        "score":  419,
        "image":  "/assets/cards/generated-filtered/fire/400-490/exp01_fire_02_ash_veil_witch__card.png"
    },
    {
        "id":  "exp01_fire_03_salamander_cavalry_lancer",
        "name":  "Salamander Cavalry Lancer",
        "element":  "fire",
        "tier":  "400-490",
        "score":  433,
        "image":  "/assets/cards/generated-filtered/fire/400-490/exp01_fire_03_salamander_cavalry_lancer__card.png"
    },
    {
        "id":  "exp02_fire_01_obsidian_glass_pyromancer",
        "name":  "Obsidian Glass Pyromancer",
        "element":  "fire",
        "tier":  "400-490",
        "score":  448,
        "image":  "/assets/cards/generated-filtered/fire/400-490/exp02_fire_01_obsidian_glass_pyromancer__card.png"
    },
    {
        "id":  "exp02_fire_03_meteorfall_knight",
        "name":  "Meteorfall Knight",
        "element":  "fire",
        "tier":  "400-490",
        "score":  462,
        "image":  "/assets/cards/generated-filtered/fire/400-490/exp02_fire_03_meteorfall_knight__card.png"
    },
    {
        "id":  "exp03_fire_05_red_comet_oracle",
        "name":  "Red Comet Oracle",
        "element":  "fire",
        "tier":  "400-490",
        "score":  476,
        "image":  "/assets/cards/generated-filtered/fire/400-490/exp03_fire_05_red_comet_oracle__card.png"
    },
    {
        "id":  "exp04_fire_05_volcano_sibyl",
        "name":  "Volcano Sibyl",
        "element":  "fire",
        "tier":  "400-490",
        "score":  490,
        "image":  "/assets/cards/generated-filtered/fire/400-490/exp04_fire_05_volcano_sibyl__card.png"
    },
    {
        "id":  "base_fire_05_dragon_warrior",
        "name":  "Dragon Warrior",
        "element":  "fire",
        "tier":  "500-590",
        "score":  505,
        "image":  "/assets/cards/generated-filtered/fire/500-590/base_fire_05_dragon_warrior__card.png"
    },
    {
        "id":  "exp01_fire_01_molten_forge_queen",
        "name":  "Molten Forge Queen",
        "element":  "fire",
        "tier":  "500-590",
        "score":  519,
        "image":  "/assets/cards/generated-filtered/fire/500-590/exp01_fire_01_molten_forge_queen__card.png"
    },
    {
        "id":  "exp01_fire_04_basalt_magma_titan",
        "name":  "Basalt Magma Titan",
        "element":  "fire",
        "tier":  "500-590",
        "score":  533,
        "image":  "/assets/cards/generated-filtered/fire/500-590/exp01_fire_04_basalt_magma_titan__card.png"
    },
    {
        "id":  "exp02_fire_02_coal_furnace_hound",
        "name":  "Coal Furnace Hound",
        "element":  "fire",
        "tier":  "500-590",
        "score":  548,
        "image":  "/assets/cards/generated-filtered/fire/500-590/exp02_fire_02_coal_furnace_hound__card.png"
    },
    {
        "id":  "exp02_fire_05_solar_lion_mask_dancer",
        "name":  "Solar Lion Mask Dancer",
        "element":  "fire",
        "tier":  "500-590",
        "score":  562,
        "image":  "/assets/cards/generated-filtered/fire/500-590/exp02_fire_05_solar_lion_mask_dancer__card.png"
    },
    {
        "id":  "exp03_fire_01_wildfire_centaur_warlord",
        "name":  "Wildfire Centaur Warlord",
        "element":  "fire",
        "tier":  "500-590",
        "score":  576,
        "image":  "/assets/cards/generated-filtered/fire/500-590/exp03_fire_01_wildfire_centaur_warlord__card.png"
    },
    {
        "id":  "exp03_fire_03_sun_forge_beetle",
        "name":  "Sun Forge Beetle",
        "element":  "fire",
        "tier":  "500-590",
        "score":  590,
        "image":  "/assets/cards/generated-filtered/fire/500-590/exp03_fire_03_sun_forge_beetle__card.png"
    },
    {
        "id":  "exp03_fire_04_lava_glass_serpent",
        "name":  "Lava Glass Serpent",
        "element":  "fire",
        "tier":  "600-680",
        "score":  610,
        "image":  "/assets/cards/generated-filtered/fire/600-680/exp03_fire_04_lava_glass_serpent__card.png"
    },
    {
        "id":  "exp04_fire_02_coal_crown_giant",
        "name":  "Coal Crown Giant",
        "element":  "fire",
        "tier":  "600-680",
        "score":  628,
        "image":  "/assets/cards/generated-filtered/fire/600-680/exp04_fire_02_coal_crown_giant__card.png"
    },
    {
        "id":  "exp05_fire_01_agni_sacred_flame_god",
        "name":  "Agni Sacred Flame God",
        "element":  "fire",
        "tier":  "600-680",
        "score":  645,
        "image":  "/assets/cards/generated-filtered/fire/600-680/exp05_fire_01_agni_sacred_flame_god__card.png"
    },
    {
        "id":  "exp05_fire_02_pele_volcano_goddess",
        "name":  "Pele Volcano Goddess",
        "element":  "fire",
        "tier":  "600-680",
        "score":  662,
        "image":  "/assets/cards/generated-filtered/fire/600-680/exp05_fire_02_pele_volcano_goddess__card.png"
    },
    {
        "id":  "exp05_fire_04_phoenix_solar_rebirth",
        "name":  "Phoenix Solar Rebirth",
        "element":  "fire",
        "tier":  "600-680",
        "score":  680,
        "image":  "/assets/cards/generated-filtered/fire/600-680/exp05_fire_04_phoenix_solar_rebirth__card.png"
    },
    {
        "id":  "base_fire_01_inferno_sovereign",
        "name":  "Inferno Sovereign",
        "element":  "fire",
        "tier":  "700-740",
        "score":  710,
        "image":  "/assets/cards/generated-filtered/fire/700-740/base_fire_01_inferno_sovereign__card.png"
    },
    {
        "id":  "exp04_fire_03_ifrit_brass_emir",
        "name":  "Ifrit Brass Emir",
        "element":  "fire",
        "tier":  "700-740",
        "score":  740,
        "image":  "/assets/cards/generated-filtered/fire/700-740/exp04_fire_03_ifrit_brass_emir__card.png"
    },
    {
        "id":  "exp05_fire_03_surtr_muspel_flame_giant",
        "name":  "Surtr Muspel Flame Giant",
        "element":  "fire",
        "tier":  "750",
        "score":  750,
        "image":  "/assets/cards/generated-filtered/fire/750/exp05_fire_03_surtr_muspel_flame_giant__card.png"
    },
    {
        "id":  "base_water_03_abyssal_oracle",
        "name":  "Abyssal Oracle",
        "element":  "water",
        "tier":  "300-390",
        "score":  310,
        "image":  "/assets/cards/generated-filtered/water/300-390/base_water_03_abyssal_oracle__card.png"
    },
    {
        "id":  "exp01_water_02_jellyfish_oracle_priestess",
        "name":  "Jellyfish Oracle Priestess",
        "element":  "water",
        "tier":  "300-390",
        "score":  326,
        "image":  "/assets/cards/generated-filtered/water/300-390/exp01_water_02_jellyfish_oracle_priestess__card.png"
    },
    {
        "id":  "exp02_water_01_ice_river_monk",
        "name":  "Ice River Monk",
        "element":  "water",
        "tier":  "300-390",
        "score":  342,
        "image":  "/assets/cards/generated-filtered/water/300-390/exp02_water_01_ice_river_monk__card.png"
    },
    {
        "id":  "exp02_water_05_abyss_lantern_diver",
        "name":  "Abyss Lantern Diver",
        "element":  "water",
        "tier":  "300-390",
        "score":  358,
        "image":  "/assets/cards/generated-filtered/water/300-390/exp02_water_05_abyss_lantern_diver__card.png"
    },
    {
        "id":  "exp03_water_05_abyss_shrine_spirit",
        "name":  "Abyss Shrine Spirit",
        "element":  "water",
        "tier":  "300-390",
        "score":  374,
        "image":  "/assets/cards/generated-filtered/water/300-390/exp03_water_05_abyss_shrine_spirit__card.png"
    },
    {
        "id":  "exp04_water_03_moon_tide_dancer",
        "name":  "Moon Tide Dancer",
        "element":  "water",
        "tier":  "300-390",
        "score":  390,
        "image":  "/assets/cards/generated-filtered/water/300-390/exp04_water_03_moon_tide_dancer__card.png"
    },
    {
        "id":  "base_water_05_stormship_captain",
        "name":  "Stormship Captain",
        "element":  "water",
        "tier":  "400-490",
        "score":  405,
        "image":  "/assets/cards/generated-filtered/water/400-490/base_water_05_stormship_captain__card.png"
    },
    {
        "id":  "exp01_water_04_drowned_samurai",
        "name":  "Drowned Samurai",
        "element":  "water",
        "tier":  "400-490",
        "score":  417,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp01_water_04_drowned_samurai__card.png"
    },
    {
        "id":  "exp02_water_03_pearl_corsair_captain",
        "name":  "Pearl Corsair Captain",
        "element":  "water",
        "tier":  "400-490",
        "score":  429,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp02_water_03_pearl_corsair_captain__card.png"
    },
    {
        "id":  "exp02_water_04_monsoon_rain_lancer",
        "name":  "Monsoon Rain Lancer",
        "element":  "water",
        "tier":  "400-490",
        "score":  441,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp02_water_04_monsoon_rain_lancer__card.png"
    },
    {
        "id":  "exp03_water_03_tide_bell_warden",
        "name":  "Tide Bell Warden",
        "element":  "water",
        "tier":  "400-490",
        "score":  454,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp03_water_03_tide_bell_warden__card.png"
    },
    {
        "id":  "exp03_water_04_rain_mirror_duelist",
        "name":  "Rain Mirror Duelist",
        "element":  "water",
        "tier":  "400-490",
        "score":  466,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp03_water_04_rain_mirror_duelist__card.png"
    },
    {
        "id":  "exp04_water_01_coral_tide_magistrate",
        "name":  "Coral Tide Magistrate",
        "element":  "water",
        "tier":  "400-490",
        "score":  478,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp04_water_01_coral_tide_magistrate__card.png"
    },
    {
        "id":  "exp04_water_05_rainwater_alchemist",
        "name":  "Rainwater Alchemist",
        "element":  "water",
        "tier":  "400-490",
        "score":  490,
        "image":  "/assets/cards/generated-filtered/water/400-490/exp04_water_05_rainwater_alchemist__card.png"
    },
    {
        "id":  "exp01_water_01_abyssal_trident_knight",
        "name":  "Abyssal Trident Knight",
        "element":  "water",
        "tier":  "500-590",
        "score":  505,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp01_water_01_abyssal_trident_knight__card.png"
    },
    {
        "id":  "exp01_water_03_leviathan_engineer",
        "name":  "Leviathan Engineer",
        "element":  "water",
        "tier":  "500-590",
        "score":  519,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp01_water_03_leviathan_engineer__card.png"
    },
    {
        "id":  "exp01_water_05_manta_sea_dragon_rider",
        "name":  "Manta Sea Dragon Rider",
        "element":  "water",
        "tier":  "500-590",
        "score":  533,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp01_water_05_manta_sea_dragon_rider__card.png"
    },
    {
        "id":  "exp02_water_02_riverback_crocoturtle",
        "name":  "Riverback Crocoturtle",
        "element":  "water",
        "tier":  "500-590",
        "score":  548,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp02_water_02_riverback_crocoturtle__card.png"
    },
    {
        "id":  "exp03_water_01_glacier_crown_queen",
        "name":  "Glacier Crown Queen",
        "element":  "water",
        "tier":  "500-590",
        "score":  562,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp03_water_01_glacier_crown_queen__card.png"
    },
    {
        "id":  "exp04_water_02_frost_tide_bear_guardian",
        "name":  "Frost Tide Bear Guardian",
        "element":  "water",
        "tier":  "500-590",
        "score":  576,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp04_water_02_frost_tide_bear_guardian__card.png"
    },
    {
        "id":  "exp04_water_04_reef_crown_serpent",
        "name":  "Reef Crown Serpent",
        "element":  "water",
        "tier":  "500-590",
        "score":  590,
        "image":  "/assets/cards/generated-filtered/water/500-590/exp04_water_04_reef_crown_serpent__card.png"
    },
    {
        "id":  "base_water_04_swamp_hydra",
        "name":  "Swamp Hydra",
        "element":  "water",
        "tier":  "600-680",
        "score":  610,
        "image":  "/assets/cards/generated-filtered/water/600-680/base_water_04_swamp_hydra__card.png"
    },
    {
        "id":  "exp03_water_02_kelp_antler_leviathan",
        "name":  "Kelp Antler Leviathan",
        "element":  "water",
        "tier":  "600-680",
        "score":  628,
        "image":  "/assets/cards/generated-filtered/water/600-680/exp03_water_02_kelp_antler_leviathan__card.png"
    },
    {
        "id":  "exp05_water_02_varuna_ocean_judge",
        "name":  "Varuna Ocean Judge",
        "element":  "water",
        "tier":  "600-680",
        "score":  645,
        "image":  "/assets/cards/generated-filtered/water/600-680/exp05_water_02_varuna_ocean_judge__card.png"
    },
    {
        "id":  "exp05_water_03_sobek_nile_crocodile_lord",
        "name":  "Sobek Nile Crocodile Lord",
        "element":  "water",
        "tier":  "600-680",
        "score":  662,
        "image":  "/assets/cards/generated-filtered/water/600-680/exp05_water_03_sobek_nile_crocodile_lord__card.png"
    },
    {
        "id":  "exp05_water_05_ryujin_dragon_palace_king",
        "name":  "Ryujin Dragon Palace King",
        "element":  "water",
        "tier":  "600-680",
        "score":  680,
        "image":  "/assets/cards/generated-filtered/water/600-680/exp05_water_05_ryujin_dragon_palace_king__card.png"
    },
    {
        "id":  "base_water_01_tide_rider",
        "name":  "Tide Rider",
        "element":  "water",
        "tier":  "700-740",
        "score":  710,
        "image":  "/assets/cards/generated-filtered/water/700-740/base_water_01_tide_rider__card.png"
    },
    {
        "id":  "base_water_02_coral_spear_champion",
        "name":  "Coral Spear Champion",
        "element":  "water",
        "tier":  "700-740",
        "score":  725,
        "image":  "/assets/cards/generated-filtered/water/700-740/base_water_02_coral_spear_champion__card.png"
    },
    {
        "id":  "exp05_water_04_tiamat_chaos_sea_dragon",
        "name":  "Tiamat Chaos Sea Dragon",
        "element":  "water",
        "tier":  "700-740",
        "score":  740,
        "image":  "/assets/cards/generated-filtered/water/700-740/exp05_water_04_tiamat_chaos_sea_dragon__card.png"
    },
    {
        "id":  "exp05_water_01_poseidon_trident_king",
        "name":  "Poseidon Trident King",
        "element":  "water",
        "tier":  "750",
        "score":  750,
        "image":  "/assets/cards/generated-filtered/water/750/exp05_water_01_poseidon_trident_king__card.png"
    },
    {
        "id":  "exp01_earth_01_blind_stone_oracle",
        "name":  "Blind Stone Oracle",
        "element":  "earth",
        "tier":  "300-390",
        "score":  310,
        "image":  "/assets/cards/generated-filtered/earth/300-390/exp01_earth_01_blind_stone_oracle__card.png"
    },
    {
        "id":  "exp02_earth_04_canyon_quake_drummer",
        "name":  "Canyon Quake Drummer",
        "element":  "earth",
        "tier":  "300-390",
        "score":  326,
        "image":  "/assets/cards/generated-filtered/earth/300-390/exp02_earth_04_canyon_quake_drummer__card.png"
    },
    {
        "id":  "exp03_earth_02_sand_compass_sage",
        "name":  "Sand Compass Sage",
        "element":  "earth",
        "tier":  "300-390",
        "score":  342,
        "image":  "/assets/cards/generated-filtered/earth/300-390/exp03_earth_02_sand_compass_sage__card.png"
    },
    {
        "id":  "exp04_earth_02_stone_sphinx_riddlekeeper",
        "name":  "Stone Sphinx Riddlekeeper",
        "element":  "earth",
        "tier":  "300-390",
        "score":  358,
        "image":  "/assets/cards/generated-filtered/earth/300-390/exp04_earth_02_stone_sphinx_riddlekeeper__card.png"
    },
    {
        "id":  "exp04_earth_03_cyclops_quarry_seer",
        "name":  "Cyclops Quarry Seer",
        "element":  "earth",
        "tier":  "300-390",
        "score":  374,
        "image":  "/assets/cards/generated-filtered/earth/300-390/exp04_earth_03_cyclops_quarry_seer__card.png"
    },
    {
        "id":  "exp05_earth_04_golem_clay_guardian",
        "name":  "Golem Clay Guardian",
        "element":  "earth",
        "tier":  "300-390",
        "score":  390,
        "image":  "/assets/cards/generated-filtered/earth/300-390/exp05_earth_04_golem_clay_guardian__card.png"
    },
    {
        "id":  "base_earth_04_cliff_stalker",
        "name":  "Cliff Stalker",
        "element":  "earth",
        "tier":  "400-490",
        "score":  405,
        "image":  "/assets/cards/generated-filtered/earth/400-490/base_earth_04_cliff_stalker__card.png"
    },
    {
        "id":  "exp01_earth_03_canyon_twin_guardians",
        "name":  "Canyon Twin Guardians",
        "element":  "earth",
        "tier":  "400-490",
        "score":  419,
        "image":  "/assets/cards/generated-filtered/earth/400-490/exp01_earth_03_canyon_twin_guardians__card.png"
    },
    {
        "id":  "exp01_earth_04_obsidian_miner_warlord",
        "name":  "Obsidian Miner Warlord",
        "element":  "earth",
        "tier":  "400-490",
        "score":  433,
        "image":  "/assets/cards/generated-filtered/earth/400-490/exp01_earth_04_obsidian_miner_warlord__card.png"
    },
    {
        "id":  "exp02_earth_02_fossil_skull_guardian",
        "name":  "Fossil Skull Guardian",
        "element":  "earth",
        "tier":  "400-490",
        "score":  448,
        "image":  "/assets/cards/generated-filtered/earth/400-490/exp02_earth_02_fossil_skull_guardian__card.png"
    },
    {
        "id":  "exp02_earth_05_geode_spider",
        "name":  "Geode Spider",
        "element":  "earth",
        "tier":  "400-490",
        "score":  462,
        "image":  "/assets/cards/generated-filtered/earth/400-490/exp02_earth_05_geode_spider__card.png"
    },
    {
        "id":  "exp03_earth_01_marble_lion_guardian",
        "name":  "Marble Lion Guardian",
        "element":  "earth",
        "tier":  "400-490",
        "score":  476,
        "image":  "/assets/cards/generated-filtered/earth/400-490/exp03_earth_01_marble_lion_guardian__card.png"
    },
    {
        "id":  "exp04_earth_04_basilisk_stone_crawler",
        "name":  "Basilisk Stone Crawler",
        "element":  "earth",
        "tier":  "400-490",
        "score":  490,
        "image":  "/assets/cards/generated-filtered/earth/400-490/exp04_earth_04_basilisk_stone_crawler__card.png"
    },
    {
        "id":  "base_earth_05_desert_sand_worm",
        "name":  "Desert Sand Worm",
        "element":  "earth",
        "tier":  "500-590",
        "score":  505,
        "image":  "/assets/cards/generated-filtered/earth/500-590/base_earth_05_desert_sand_worm__card.png"
    },
    {
        "id":  "exp01_earth_02_crystal_beetle_knight",
        "name":  "Crystal Beetle Knight",
        "element":  "earth",
        "tier":  "500-590",
        "score":  519,
        "image":  "/assets/cards/generated-filtered/earth/500-590/exp01_earth_02_crystal_beetle_knight__card.png"
    },
    {
        "id":  "exp01_earth_05_sand_shell_fortress_golem",
        "name":  "Sand Shell Fortress Golem",
        "element":  "earth",
        "tier":  "500-590",
        "score":  533,
        "image":  "/assets/cards/generated-filtered/earth/500-590/exp01_earth_05_sand_shell_fortress_golem__card.png"
    },
    {
        "id":  "exp02_earth_03_jade_elephant_sentinel",
        "name":  "Jade Elephant Sentinel",
        "element":  "earth",
        "tier":  "500-590",
        "score":  548,
        "image":  "/assets/cards/generated-filtered/earth/500-590/exp02_earth_03_jade_elephant_sentinel__card.png"
    },
    {
        "id":  "exp03_earth_03_onyx_centipede_monarch",
        "name":  "Onyx Centipede Monarch",
        "element":  "earth",
        "tier":  "500-590",
        "score":  562,
        "image":  "/assets/cards/generated-filtered/earth/500-590/exp03_earth_03_onyx_centipede_monarch__card.png"
    },
    {
        "id":  "exp03_earth_05_mudborn_clay_colossus",
        "name":  "Mudborn Clay Colossus",
        "element":  "earth",
        "tier":  "500-590",
        "score":  576,
        "image":  "/assets/cards/generated-filtered/earth/500-590/exp03_earth_05_mudborn_clay_colossus__card.png"
    },
    {
        "id":  "exp04_earth_01_labyrinth_minotaur_mason",
        "name":  "Labyrinth Minotaur Mason",
        "element":  "earth",
        "tier":  "500-590",
        "score":  590,
        "image":  "/assets/cards/generated-filtered/earth/500-590/exp04_earth_01_labyrinth_minotaur_mason__card.png"
    },
    {
        "id":  "base_earth_02_frost_chain_titan",
        "name":  "Frost Chain Titan",
        "element":  "earth",
        "tier":  "600-680",
        "score":  610,
        "image":  "/assets/cards/generated-filtered/earth/600-680/base_earth_02_frost_chain_titan__card.png"
    },
    {
        "id":  "exp04_earth_05_atlas_stonebearer_titan",
        "name":  "Atlas Stonebearer Titan",
        "element":  "earth",
        "tier":  "600-680",
        "score":  628,
        "image":  "/assets/cards/generated-filtered/earth/600-680/exp04_earth_05_atlas_stonebearer_titan__card.png"
    },
    {
        "id":  "exp05_earth_01_gaia_world_mother",
        "name":  "Gaia World Mother",
        "element":  "earth",
        "tier":  "600-680",
        "score":  645,
        "image":  "/assets/cards/generated-filtered/earth/600-680/exp05_earth_01_gaia_world_mother__card.png"
    },
    {
        "id":  "exp05_earth_02_geb_earth_father",
        "name":  "Geb Earth Father",
        "element":  "earth",
        "tier":  "600-680",
        "score":  662,
        "image":  "/assets/cards/generated-filtered/earth/600-680/exp05_earth_02_geb_earth_father__card.png"
    },
    {
        "id":  "exp05_earth_03_pachamama_mountain_mother",
        "name":  "Pachamama Mountain Mother",
        "element":  "earth",
        "tier":  "600-680",
        "score":  680,
        "image":  "/assets/cards/generated-filtered/earth/600-680/exp05_earth_03_pachamama_mountain_mother__card.png"
    },
    {
        "id":  "base_earth_01_canyon_stone_guardian",
        "name":  "Canyon Stone Guardian",
        "element":  "earth",
        "tier":  "700-740",
        "score":  710,
        "image":  "/assets/cards/generated-filtered/earth/700-740/base_earth_01_canyon_stone_guardian__card.png"
    },
    {
        "id":  "base_earth_03_badlands_geomancer",
        "name":  "Badlands Geomancer",
        "element":  "earth",
        "tier":  "700-740",
        "score":  740,
        "image":  "/assets/cards/generated-filtered/earth/700-740/base_earth_03_badlands_geomancer__card.png"
    },
    {
        "id":  "exp05_earth_05_ymir_primeval_giant",
        "name":  "Ymir Primeval Giant",
        "element":  "earth",
        "tier":  "750",
        "score":  750,
        "image":  "/assets/cards/generated-filtered/earth/750/exp05_earth_05_ymir_primeval_giant__card.png"
    },
    {
        "id":  "base_nature_05_rainbow_coin_gnome",
        "name":  "Rainbow Coin Gnome",
        "element":  "nature",
        "tier":  "300-390",
        "score":  310,
        "image":  "/assets/cards/generated-filtered/nature/300-390/base_nature_05_rainbow_coin_gnome__card.png"
    },
    {
        "id":  "exp01_nature_04_autumn_leaf_ranger",
        "name":  "Autumn Leaf Ranger",
        "element":  "nature",
        "tier":  "300-390",
        "score":  326,
        "image":  "/assets/cards/generated-filtered/nature/300-390/exp01_nature_04_autumn_leaf_ranger__card.png"
    },
    {
        "id":  "exp02_nature_01_orchid_surgeon_druid",
        "name":  "Orchid Surgeon Druid",
        "element":  "nature",
        "tier":  "300-390",
        "score":  342,
        "image":  "/assets/cards/generated-filtered/nature/300-390/exp02_nature_01_orchid_surgeon_druid__card.png"
    },
    {
        "id":  "exp03_nature_01_moss_falconer_sentinel",
        "name":  "Moss Falconer Sentinel",
        "element":  "nature",
        "tier":  "300-390",
        "score":  358,
        "image":  "/assets/cards/generated-filtered/nature/300-390/exp03_nature_01_moss_falconer_sentinel__card.png"
    },
    {
        "id":  "exp04_nature_03_faun_briar_spear_champion",
        "name":  "Faun Briar Spear Champion",
        "element":  "nature",
        "tier":  "300-390",
        "score":  374,
        "image":  "/assets/cards/generated-filtered/nature/300-390/exp04_nature_03_faun_briar_spear_champion__card.png"
    },
    {
        "id":  "exp05_nature_03_pan_forest_goat_god",
        "name":  "Pan Forest Goat God",
        "element":  "nature",
        "tier":  "300-390",
        "score":  390,
        "image":  "/assets/cards/generated-filtered/nature/300-390/exp05_nature_03_pan_forest_goat_god__card.png"
    },
    {
        "id":  "base_nature_02_single_forest_sprite_realistic_v2",
        "name":  "Single Forest Sprite Realistic V2",
        "element":  "nature",
        "tier":  "400-490",
        "score":  405,
        "image":  "/assets/cards/generated-filtered/nature/400-490/base_nature_02_single_forest_sprite_realistic_v2__card.png"
    },
    {
        "id":  "exp01_nature_02_swamp_apothecary_druid",
        "name":  "Swamp Apothecary Druid",
        "element":  "nature",
        "tier":  "400-490",
        "score":  417,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp01_nature_02_swamp_apothecary_druid__card.png"
    },
    {
        "id":  "exp02_nature_04_ancient_root_ferryman",
        "name":  "Ancient Root Ferryman",
        "element":  "nature",
        "tier":  "400-490",
        "score":  429,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp02_nature_04_ancient_root_ferryman__card.png"
    },
    {
        "id":  "exp03_nature_04_carnivorous_vine_harpist",
        "name":  "Carnivorous Vine Harpist",
        "element":  "nature",
        "tier":  "400-490",
        "score":  441,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp03_nature_04_carnivorous_vine_harpist__card.png"
    },
    {
        "id":  "exp03_nature_05_canopy_shield_maiden",
        "name":  "Canopy Shield Maiden",
        "element":  "nature",
        "tier":  "400-490",
        "score":  454,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp03_nature_05_canopy_shield_maiden__card.png"
    },
    {
        "id":  "exp04_nature_01_ancient_dryad_matriarch",
        "name":  "Ancient Dryad Matriarch",
        "element":  "nature",
        "tier":  "400-490",
        "score":  466,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp04_nature_01_ancient_dryad_matriarch__card.png"
    },
    {
        "id":  "exp04_nature_05_wild_hunt_bramble_hound",
        "name":  "Wild Hunt Bramble Hound",
        "element":  "nature",
        "tier":  "400-490",
        "score":  478,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp04_nature_05_wild_hunt_bramble_hound__card.png"
    },
    {
        "id":  "exp05_nature_01_artemis_wild_huntress",
        "name":  "Artemis Wild Huntress",
        "element":  "nature",
        "tier":  "400-490",
        "score":  490,
        "image":  "/assets/cards/generated-filtered/nature/400-490/exp05_nature_01_artemis_wild_huntress__card.png"
    },
    {
        "id":  "exp01_nature_01_stag_horn_forest_sentinel",
        "name":  "Stag Horn Forest Sentinel",
        "element":  "nature",
        "tier":  "500-590",
        "score":  505,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp01_nature_01_stag_horn_forest_sentinel__card.png"
    },
    {
        "id":  "exp01_nature_03_carnivorous_orchid_mantis",
        "name":  "Carnivorous Orchid Mantis",
        "element":  "nature",
        "tier":  "500-590",
        "score":  519,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp01_nature_03_carnivorous_orchid_mantis__card.png"
    },
    {
        "id":  "exp02_nature_02_vine_panther_predator",
        "name":  "Vine Panther Predator",
        "element":  "nature",
        "tier":  "500-590",
        "score":  533,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp02_nature_02_vine_panther_predator__card.png"
    },
    {
        "id":  "exp02_nature_05_thorn_boar_colossus",
        "name":  "Thorn Boar Colossus",
        "element":  "nature",
        "tier":  "500-590",
        "score":  548,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp02_nature_05_thorn_boar_colossus__card.png"
    },
    {
        "id":  "exp03_nature_02_thorn_dryad_knight",
        "name":  "Thorn Dryad Knight",
        "element":  "nature",
        "tier":  "500-590",
        "score":  562,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp03_nature_02_thorn_dryad_knight__card.png"
    },
    {
        "id":  "exp03_nature_03_moss_mammoth_elder",
        "name":  "Moss Mammoth Elder",
        "element":  "nature",
        "tier":  "500-590",
        "score":  576,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp03_nature_03_moss_mammoth_elder__card.png"
    },
    {
        "id":  "exp04_nature_02_leshy_horned_warden",
        "name":  "Leshy Horned Warden",
        "element":  "nature",
        "tier":  "500-590",
        "score":  590,
        "image":  "/assets/cards/generated-filtered/nature/500-590/exp04_nature_02_leshy_horned_warden__card.png"
    },
    {
        "id":  "base_nature_04_ancient_tree_form",
        "name":  "Ancient Tree Form",
        "element":  "nature",
        "tier":  "600-680",
        "score":  610,
        "image":  "/assets/cards/generated-filtered/nature/600-680/base_nature_04_ancient_tree_form__card.png"
    },
    {
        "id":  "exp01_nature_05_fungal_colossus_beast",
        "name":  "Fungal Colossus Beast",
        "element":  "nature",
        "tier":  "600-680",
        "score":  628,
        "image":  "/assets/cards/generated-filtered/nature/600-680/exp01_nature_05_fungal_colossus_beast__card.png"
    },
    {
        "id":  "exp02_nature_03_honeycomb_war_queen",
        "name":  "Honeycomb War Queen",
        "element":  "nature",
        "tier":  "600-680",
        "score":  645,
        "image":  "/assets/cards/generated-filtered/nature/600-680/exp02_nature_03_honeycomb_war_queen__card.png"
    },
    {
        "id":  "exp04_nature_04_green_man_vine_prophet",
        "name":  "Green Man Vine Prophet",
        "element":  "nature",
        "tier":  "600-680",
        "score":  662,
        "image":  "/assets/cards/generated-filtered/nature/600-680/exp04_nature_04_green_man_vine_prophet__card.png"
    },
    {
        "id":  "exp05_nature_05_demeter_harvest_mother",
        "name":  "Demeter Harvest Mother",
        "element":  "nature",
        "tier":  "600-680",
        "score":  680,
        "image":  "/assets/cards/generated-filtered/nature/600-680/exp05_nature_05_demeter_harvest_mother__card.png"
    },
    {
        "id":  "base_nature_01_forest_guardian_no_breath",
        "name":  "Forest Guardian No Breath",
        "element":  "nature",
        "tier":  "700-740",
        "score":  710,
        "image":  "/assets/cards/generated-filtered/nature/700-740/base_nature_01_forest_guardian_no_breath__card.png"
    },
    {
        "id":  "base_nature_03_daylight_flower_guardian",
        "name":  "Daylight Flower Guardian",
        "element":  "nature",
        "tier":  "700-740",
        "score":  725,
        "image":  "/assets/cards/generated-filtered/nature/700-740/base_nature_03_daylight_flower_guardian__card.png"
    },
    {
        "id":  "exp05_nature_02_cernunnos_horned_god",
        "name":  "Cernunnos Horned God",
        "element":  "nature",
        "tier":  "700-740",
        "score":  740,
        "image":  "/assets/cards/generated-filtered/nature/700-740/exp05_nature_02_cernunnos_horned_god__card.png"
    },
    {
        "id":  "exp05_nature_04_yggdrasil_world_tree",
        "name":  "Yggdrasil World Tree",
        "element":  "nature",
        "tier":  "750",
        "score":  750,
        "image":  "/assets/cards/generated-filtered/nature/750/exp05_nature_04_yggdrasil_world_tree__card.png"
    },
    {
        "id":  "base_shadow_03_mauve_wrinkled_shadow_mage",
        "name":  "Mauve Wrinkled Shadow Mage",
        "element":  "shadow",
        "tier":  "300-390",
        "score":  310,
        "image":  "/assets/cards/generated-filtered/shadow/300-390/base_shadow_03_mauve_wrinkled_shadow_mage__card.png"
    },
    {
        "id":  "base_shadow_05_mauve_shadow_monk",
        "name":  "Mauve Shadow Monk",
        "element":  "shadow",
        "tier":  "300-390",
        "score":  326,
        "image":  "/assets/cards/generated-filtered/shadow/300-390/base_shadow_05_mauve_shadow_monk__card.png"
    },
    {
        "id":  "exp01_shadow_05_blind_shadow_mourner",
        "name":  "Blind Shadow Mourner",
        "element":  "shadow",
        "tier":  "300-390",
        "score":  342,
        "image":  "/assets/cards/generated-filtered/shadow/300-390/exp01_shadow_05_blind_shadow_mourner__card.png"
    },
    {
        "id":  "exp02_shadow_02_ink_blood_scribe",
        "name":  "Ink Blood Scribe",
        "element":  "shadow",
        "tier":  "300-390",
        "score":  358,
        "image":  "/assets/cards/generated-filtered/shadow/300-390/exp02_shadow_02_ink_blood_scribe__card.png"
    },
    {
        "id":  "exp03_shadow_03_void_horse_revenant",
        "name":  "Void Horse Revenant",
        "element":  "shadow",
        "tier":  "300-390",
        "score":  374,
        "image":  "/assets/cards/generated-filtered/shadow/300-390/exp03_shadow_03_void_horse_revenant__card.png"
    },
    {
        "id":  "exp03_shadow_05_silent_well_spirit",
        "name":  "Silent Well Spirit",
        "element":  "shadow",
        "tier":  "300-390",
        "score":  390,
        "image":  "/assets/cards/generated-filtered/shadow/300-390/exp03_shadow_05_silent_well_spirit__card.png"
    },
    {
        "id":  "base_shadow_01_terrifying_moon_assassin",
        "name":  "Terrifying Moon Assassin",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  405,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/base_shadow_01_terrifying_moon_assassin__card.png"
    },
    {
        "id":  "base_shadow_02_serpent_hair_witch",
        "name":  "Serpent Hair Witch",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  419,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/base_shadow_02_serpent_hair_witch__card.png"
    },
    {
        "id":  "exp01_shadow_02_grave_oracle",
        "name":  "Grave Oracle",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  433,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/exp01_shadow_02_grave_oracle__card.png"
    },
    {
        "id":  "exp02_shadow_01_puppet_judge",
        "name":  "Puppet Judge",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  448,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/exp02_shadow_01_puppet_judge__card.png"
    },
    {
        "id":  "exp03_shadow_01_black_lantern_jailer",
        "name":  "Black Lantern Jailer",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  462,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/exp03_shadow_01_black_lantern_jailer__card.png"
    },
    {
        "id":  "exp03_shadow_02_eclipse_ballerina",
        "name":  "Eclipse Ballerina",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  476,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/exp03_shadow_02_eclipse_ballerina__card.png"
    },
    {
        "id":  "exp04_shadow_02_raven_morrigan_warseer",
        "name":  "Raven Morrigan Warseer",
        "element":  "shadow",
        "tier":  "400-490",
        "score":  490,
        "image":  "/assets/cards/generated-filtered/shadow/400-490/exp04_shadow_02_raven_morrigan_warseer__card.png"
    },
    {
        "id":  "base_shadow_04_nightmare_beast",
        "name":  "Nightmare Beast",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  505,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/base_shadow_04_nightmare_beast__card.png"
    },
    {
        "id":  "exp01_shadow_01_mirror_assassin",
        "name":  "Mirror Assassin",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  519,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/exp01_shadow_01_mirror_assassin__card.png"
    },
    {
        "id":  "exp01_shadow_03_serpent_hair_duelist",
        "name":  "Serpent Hair Duelist",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  533,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/exp01_shadow_03_serpent_hair_duelist__card.png"
    },
    {
        "id":  "exp02_shadow_03_cathedral_spider_nun",
        "name":  "Cathedral Spider Nun",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  548,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/exp02_shadow_03_cathedral_spider_nun__card.png"
    },
    {
        "id":  "exp02_shadow_04_faceless_shadow_butcher",
        "name":  "Faceless Shadow Butcher",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  562,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/exp02_shadow_04_faceless_shadow_butcher__card.png"
    },
    {
        "id":  "exp02_shadow_05_moon_moth_reaper",
        "name":  "Moon Moth Reaper",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  576,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/exp02_shadow_05_moon_moth_reaper__card.png"
    },
    {
        "id":  "exp04_shadow_04_lamia_veil_assassin",
        "name":  "Lamia Veil Assassin",
        "element":  "shadow",
        "tier":  "500-590",
        "score":  590,
        "image":  "/assets/cards/generated-filtered/shadow/500-590/exp04_shadow_04_lamia_veil_assassin__card.png"
    },
    {
        "id":  "exp01_shadow_04_eclipse_nightmare_stag",
        "name":  "Eclipse Nightmare Stag",
        "element":  "shadow",
        "tier":  "600-680",
        "score":  610,
        "image":  "/assets/cards/generated-filtered/shadow/600-680/exp01_shadow_04_eclipse_nightmare_stag__card.png"
    },
    {
        "id":  "exp03_shadow_04_bone_mask_collector",
        "name":  "Bone Mask Collector",
        "element":  "shadow",
        "tier":  "600-680",
        "score":  628,
        "image":  "/assets/cards/generated-filtered/shadow/600-680/exp03_shadow_04_bone_mask_collector__card.png"
    },
    {
        "id":  "exp05_shadow_01_anubis_soul_weigher",
        "name":  "Anubis Soul Weigher",
        "element":  "shadow",
        "tier":  "600-680",
        "score":  645,
        "image":  "/assets/cards/generated-filtered/shadow/600-680/exp05_shadow_01_anubis_soul_weigher__card.png"
    },
    {
        "id":  "exp05_shadow_02_hades_underworld_king",
        "name":  "Hades Underworld King",
        "element":  "shadow",
        "tier":  "600-680",
        "score":  662,
        "image":  "/assets/cards/generated-filtered/shadow/600-680/exp05_shadow_02_hades_underworld_king__card.png"
    },
    {
        "id":  "exp05_shadow_03_hel_half_shadow_queen",
        "name":  "Hel Half Shadow Queen",
        "element":  "shadow",
        "tier":  "600-680",
        "score":  680,
        "image":  "/assets/cards/generated-filtered/shadow/600-680/exp05_shadow_03_hel_half_shadow_queen__card.png"
    },
    {
        "id":  "exp04_shadow_03_nightmare_onyx_horseman",
        "name":  "Nightmare Onyx Horseman",
        "element":  "shadow",
        "tier":  "700-740",
        "score":  710,
        "image":  "/assets/cards/generated-filtered/shadow/700-740/exp04_shadow_03_nightmare_onyx_horseman__card.png"
    },
    {
        "id":  "exp04_shadow_05_hades_gate_warden",
        "name":  "Hades Gate Warden",
        "element":  "shadow",
        "tier":  "700-740",
        "score":  740,
        "image":  "/assets/cards/generated-filtered/shadow/700-740/exp04_shadow_05_hades_gate_warden__card.png"
    },
    {
        "id":  "exp04_shadow_01_eclipse_wraith_psychopomp",
        "name":  "Eclipse Wraith Psychopomp",
        "element":  "shadow",
        "tier":  "750",
        "score":  750,
        "image":  "/assets/cards/generated-filtered/shadow/750/exp04_shadow_01_eclipse_wraith_psychopomp__card.png"
    },
    {
        "id":  "base_electric_04_storm_oracle",
        "name":  "Storm Oracle",
        "element":  "electric",
        "tier":  "300-390",
        "score":  310,
        "image":  "/assets/cards/generated-filtered/electric/300-390/base_electric_04_storm_oracle__card.png"
    },
    {
        "id":  "exp01_electric_02_antique_lightning_automaton",
        "name":  "Antique Lightning Automaton",
        "element":  "electric",
        "tier":  "300-390",
        "score":  323,
        "image":  "/assets/cards/generated-filtered/electric/300-390/exp01_electric_02_antique_lightning_automaton__card.png"
    },
    {
        "id":  "exp02_electric_04_prism_lightning_mage",
        "name":  "Prism Lightning Mage",
        "element":  "electric",
        "tier":  "300-390",
        "score":  337,
        "image":  "/assets/cards/generated-filtered/electric/300-390/exp02_electric_04_prism_lightning_mage__card.png"
    },
    {
        "id":  "exp03_electric_01_magnetic_armor_lancer",
        "name":  "Magnetic Armor Lancer",
        "element":  "electric",
        "tier":  "300-390",
        "score":  350,
        "image":  "/assets/cards/generated-filtered/electric/300-390/exp03_electric_01_magnetic_armor_lancer__card.png"
    },
    {
        "id":  "exp03_electric_03_lightning_violin_virtuoso",
        "name":  "Lightning Violin Virtuoso",
        "element":  "electric",
        "tier":  "300-390",
        "score":  363,
        "image":  "/assets/cards/generated-filtered/electric/300-390/exp03_electric_03_lightning_violin_virtuoso__card.png"
    },
    {
        "id":  "exp03_electric_05_aurora_sentinel",
        "name":  "Aurora Sentinel",
        "element":  "electric",
        "tier":  "300-390",
        "score":  377,
        "image":  "/assets/cards/generated-filtered/electric/300-390/exp03_electric_05_aurora_sentinel__card.png"
    },
    {
        "id":  "exp04_electric_04_valkyrie_lightning_lancer",
        "name":  "Valkyrie Lightning Lancer",
        "element":  "electric",
        "tier":  "300-390",
        "score":  390,
        "image":  "/assets/cards/generated-filtered/electric/300-390/exp04_electric_04_valkyrie_lightning_lancer__card.png"
    },
    {
        "id":  "base_electric_01_stormblade_duelist",
        "name":  "Stormblade Duelist",
        "element":  "electric",
        "tier":  "400-490",
        "score":  405,
        "image":  "/assets/cards/generated-filtered/electric/400-490/base_electric_01_stormblade_duelist__card.png"
    },
    {
        "id":  "exp01_electric_01_storm_priest",
        "name":  "Storm Priest",
        "element":  "electric",
        "tier":  "400-490",
        "score":  417,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp01_electric_01_storm_priest__card.png"
    },
    {
        "id":  "exp01_electric_03_thunder_rooftop_archer",
        "name":  "Thunder Rooftop Archer",
        "element":  "electric",
        "tier":  "400-490",
        "score":  429,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp01_electric_03_thunder_rooftop_archer__card.png"
    },
    {
        "id":  "exp01_electric_04_plasma_eel_rider",
        "name":  "Plasma Eel Rider",
        "element":  "electric",
        "tier":  "400-490",
        "score":  441,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp01_electric_04_plasma_eel_rider__card.png"
    },
    {
        "id":  "exp02_electric_01_thunder_drum_conductor",
        "name":  "Thunder Drum Conductor",
        "element":  "electric",
        "tier":  "400-490",
        "score":  454,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp02_electric_01_thunder_drum_conductor__card.png"
    },
    {
        "id":  "exp02_electric_03_lightning_ibex_rider",
        "name":  "Lightning Ibex Rider",
        "element":  "electric",
        "tier":  "400-490",
        "score":  466,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp02_electric_03_lightning_ibex_rider__card.png"
    },
    {
        "id":  "exp02_electric_05_capacitor_knight",
        "name":  "Capacitor Knight",
        "element":  "electric",
        "tier":  "400-490",
        "score":  478,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp02_electric_05_capacitor_knight__card.png"
    },
    {
        "id":  "exp03_electric_04_storm_artillery_smith",
        "name":  "Storm Artillery Smith",
        "element":  "electric",
        "tier":  "400-490",
        "score":  490,
        "image":  "/assets/cards/generated-filtered/electric/400-490/exp03_electric_04_storm_artillery_smith__card.png"
    },
    {
        "id":  "base_electric_02_frankenstein_storm_colossus",
        "name":  "Frankenstein Storm Colossus",
        "element":  "electric",
        "tier":  "500-590",
        "score":  505,
        "image":  "/assets/cards/generated-filtered/electric/500-590/base_electric_02_frankenstein_storm_colossus__card.png"
    },
    {
        "id":  "base_electric_03_tesla_storm_golem",
        "name":  "Tesla Storm Golem",
        "element":  "electric",
        "tier":  "500-590",
        "score":  517,
        "image":  "/assets/cards/generated-filtered/electric/500-590/base_electric_03_tesla_storm_golem__card.png"
    },
    {
        "id":  "base_electric_05_storm_serpent",
        "name":  "Storm Serpent",
        "element":  "electric",
        "tier":  "500-590",
        "score":  529,
        "image":  "/assets/cards/generated-filtered/electric/500-590/base_electric_05_storm_serpent__card.png"
    },
    {
        "id":  "exp01_electric_05_lab_born_storm_colossus",
        "name":  "Lab Born Storm Colossus",
        "element":  "electric",
        "tier":  "500-590",
        "score":  541,
        "image":  "/assets/cards/generated-filtered/electric/500-590/exp01_electric_05_lab_born_storm_colossus__card.png"
    },
    {
        "id":  "exp02_electric_02_storm_crab_leviathan",
        "name":  "Storm Crab Leviathan",
        "element":  "electric",
        "tier":  "500-590",
        "score":  554,
        "image":  "/assets/cards/generated-filtered/electric/500-590/exp02_electric_02_storm_crab_leviathan__card.png"
    },
    {
        "id":  "exp03_electric_02_thunder_moth_titan",
        "name":  "Thunder Moth Titan",
        "element":  "electric",
        "tier":  "500-590",
        "score":  566,
        "image":  "/assets/cards/generated-filtered/electric/500-590/exp03_electric_02_thunder_moth_titan__card.png"
    },
    {
        "id":  "exp04_electric_01_thunderbird_storm_avatar",
        "name":  "Thunderbird Storm Avatar",
        "element":  "electric",
        "tier":  "500-590",
        "score":  578,
        "image":  "/assets/cards/generated-filtered/electric/500-590/exp04_electric_01_thunderbird_storm_avatar__card.png"
    },
    {
        "id":  "exp04_electric_02_raijin_drum_summoner",
        "name":  "Raijin Drum Summoner",
        "element":  "electric",
        "tier":  "500-590",
        "score":  590,
        "image":  "/assets/cards/generated-filtered/electric/500-590/exp04_electric_02_raijin_drum_summoner__card.png"
    },
    {
        "id":  "exp04_electric_05_quetzalcoatl_storm_serpent",
        "name":  "Quetzalcoatl Storm Serpent",
        "element":  "electric",
        "tier":  "600-680",
        "score":  610,
        "image":  "/assets/cards/generated-filtered/electric/600-680/exp04_electric_05_quetzalcoatl_storm_serpent__card.png"
    },
    {
        "id":  "exp05_electric_02_indra_vajra_storm_king",
        "name":  "Indra Vajra Storm King",
        "element":  "electric",
        "tier":  "600-680",
        "score":  628,
        "image":  "/assets/cards/generated-filtered/electric/600-680/exp05_electric_02_indra_vajra_storm_king__card.png"
    },
    {
        "id":  "exp05_electric_03_perun_thunder_axe",
        "name":  "Perun Thunder Axe",
        "element":  "electric",
        "tier":  "600-680",
        "score":  645,
        "image":  "/assets/cards/generated-filtered/electric/600-680/exp05_electric_03_perun_thunder_axe__card.png"
    },
    {
        "id":  "exp05_electric_04_chaac_rain_thunder_lord",
        "name":  "Chaac Rain Thunder Lord",
        "element":  "electric",
        "tier":  "600-680",
        "score":  662,
        "image":  "/assets/cards/generated-filtered/electric/600-680/exp05_electric_04_chaac_rain_thunder_lord__card.png"
    },
    {
        "id":  "exp05_electric_05_shango_thunder_orisha",
        "name":  "Shango Thunder Orisha",
        "element":  "electric",
        "tier":  "600-680",
        "score":  680,
        "image":  "/assets/cards/generated-filtered/electric/600-680/exp05_electric_05_shango_thunder_orisha__card.png"
    },
    {
        "id":  "exp05_electric_01_thor_mjolnir_thunderer",
        "name":  "Thor Mjolnir Thunderer",
        "element":  "electric",
        "tier":  "700-740",
        "score":  710,
        "image":  "/assets/cards/generated-filtered/electric/700-740/exp05_electric_01_thor_mjolnir_thunderer__card.png"
    },
    {
        "id":  "exp05_electric_extra_01_kali_time_destroyer",
        "name":  "Electric Extra 01 Kali Time Destroyer",
        "element":  "electric",
        "tier":  "700-740",
        "score":  725,
        "image":  "/assets/cards/generated-filtered/electric/700-740/exp05_electric_extra_01_kali_time_destroyer__card.png"
    },
    {
        "id":  "exp05_electric_extra_02_hecate_crossroads_witch",
        "name":  "Electric Extra 02 Hecate Crossroads Witch",
        "element":  "electric",
        "tier":  "700-740",
        "score":  740,
        "image":  "/assets/cards/generated-filtered/electric/700-740/exp05_electric_extra_02_hecate_crossroads_witch__card.png"
    },
    {
        "id":  "exp04_electric_03_zeus_aegis_spear_lord",
        "name":  "Zeus Aegis Spear Lord",
        "element":  "electric",
        "tier":  "750",
        "score":  750,
        "image":  "/assets/cards/generated-filtered/electric/750/exp04_electric_03_zeus_aegis_spear_lord__card.png"
    }
];

export const CARD_TOTAL = CARD_CATALOG.length;

